import type { UserPreferences } from '@texas42/app-model';
import { normalizeAnimationSpeed, resolveReducedMotion } from './settings-data.js';

export function applyUserPreferencesToDocument(
  preferences: UserPreferences,
  root?: HTMLElement,
): void {
  const target =
    root ?? (typeof document !== 'undefined' ? document.documentElement : undefined);
  if (!target) return;

  const reducedMotion = resolveReducedMotion(preferences);
  const animationSpeed = normalizeAnimationSpeed(preferences);

  target.dataset.tx42HighContrast = preferences.highContrastMode ? 'true' : 'false';
  target.dataset.tx42LargeDomino = preferences.largeDominoMode ? 'true' : 'false';
  target.dataset.tx42ColorfulPips = preferences.colorfulPips ? 'true' : 'false';
  target.dataset.tx42ReducedMotion = reducedMotion ? 'true' : 'false';
  target.dataset.tx42AnimationSpeed = animationSpeed;
}
